export default "__VITE_ASSET__8c8e4d8d__"